import { LockClosedIcon } from '@heroicons/react/solid'
import Logo from '../assets/logo.png'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Link } from 'react-router-dom';


export default function Login() {

    const navigate = useNavigate();
    navigate('/Home');

    const [redirect,setRedirect] = useState(false)

    const redirection = ()=>{

        setRedirect(true);
        if(redirect){

            return <navigate to ='/Home'/>
        }
    }
    return (
        <>




            <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-md space-y-8">
                    <div>
                        <img
                            style={{}}
                            className="mx-auto h-40 w-64"
                            src={Logo}
                            alt="Workflow"
                        />
                        <h2 className=" text-center text-3xl font-extrabold text-gray-900">Sign in to your account</h2>
                    </div>
                    {/*
                  WHAT TO DO WHEN USING LARAVEL

          <form className="mt-8 space-y-6" action="#" method="POST"> */}

                    <form className="mt-8 space-y-6" onSubmit={redirection} >
                        <input type="hidden" name="remember" defaultValue="true" />
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="email-address" className="sr-only">
                                    Email address
                                </label>
                                <input
                                    id="email-address"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-green-700 focus:border-green-700 focus:z-10 sm:text-sm"
                                    placeholder="Email address"
                                />
                            </div>
                            <div className = "mt-3">
                                <label htmlFor="password" className="sr-only">
                                    Password
                                </label>
                                <input
                                    id="password"
                                    name="password"
                                    type="password"
                                    autoComplete="current-password"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-green-700 focus:border-green-700 focus:z-10 sm:text-sm"
                                    placeholder="Password"
                                />
                            </div>
                        </div>

                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <input
                                    id="remember-me"
                                    name="remember-me"
                                    type="checkbox"
                                    className="h-4 w-4 text-green-700 focus:ring-green-600 border-gray-300 rounded"
                                />
                                <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                                    Remember me
                                </label>
                            </div>


                            <div className="text-sm">
                                <p className = "h-1">Are you a new client?</p>
                                <Link to="/SignIn" className="font-medium text-green-700 hover:text-green-600">
                                    Please Sign in
                                </Link>
                            </div>
                        </div>

                        <div>
                            <button

                                type="submit"
                                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-700 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                            >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <LockClosedIcon className="h-5 w-5 text-gray-100 group-hover:text-gray-600" aria-hidden="true" />
                </span>
                                Log in
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}